import { log, supabase } from ".";

export const getSubcategorias = async () => {
  try {
    const data = await supabase.select("subcategorias", {
      orderBy: [{ column: "orden", ascending: true }],
    });
    return data || [];
  } catch (error) {
    log.error("getSubcategorias", error);
    return [];
  }
};
